export const getWarning = (parent: string, child: string | string[]) => {
  if (Array.isArray(child)) {
    child = child.join(' or ');
  }
  return `Child of ${parent} is not ${child} type`;
};
